export default __webpack_public_path__ + "static/pump_b.21c6e3c6bf1cb71e5031d3b4e4311a97.png";